// For IBM Stand & Deliver customizations in the Enablement Exchange edition
const sdId = 37;
const sdChannelDetails =
  "Channels are spaces for practice and feedback";
const sdTitle = "Stand & Deliver";
const sdSummary = "This is your space to prepare for client conversations.";
const sdDescription = `
  <p>
    This is your space to <em>prepare</em> for client conversations,
    <em>perfect</em> pitches, and <em>demonstrate</em> your skills - and to
    <em>engage</em> peers, mentors and subject matter experts for feedback and
    coaching along the way.
  </p>

  <p>
    When you create any Stand & Deliver video, we suggest reviewing the PDF rubric
    below. As a manager you can draw on the rubric to guide your feedback.
  </p>

  <ul>
    <li>
      <a
        target="_blank"
        href="https://media-live.nomadic.fm/misc/Stand_and_Deliver_Feedback_Rubric.pdf"
        >Downloadable interactive PDF rubric</a
      >
      (to help prepare and to help structure feedback)
    </li>
    <li>
      <a
        target="_blank"
        href="/resource-library/manager-led-stand-deliver-challenges"
        >Instructions</a
      >
       for creating your own Stand & Deliver Challenge for your team
    </li>
  </ul>

  <div class="accordion">
    <input type="checkbox" name="s-d-instructions" id="s-d-feedback">
    <div>
      <label for="s-d-feedback">
        How do I use this channel to post content and receive feedback?
      </label>
      <div>
        <p>
          To get started, click 'Add Member' and, in the pop-up window, search for
          the people you'd like to view your video (for instance, your manager or a subject
          matter expert). Then, create a new post, @mention the reviewer in the body, and attach your
          Stand & Deliver video (whether it's a pitch, a conversation starter, or a
          dialogue you've captured) for feedback. You must also tag your post. Select one Topic tag
          (Cloud, for example), one Geo tag and one Industry tag. Your reviewer will receive a notification
          to review your video post. You will receive a notification when your reviewer has posted feedback.
        </p>
        <p>
          Links to content rubrics for particular Stand & Deliver Challenges can be found below.
        </p>
        <p>
          If you're not able to add your reviewer they may have not yet joined the
          platform. Continue to upload your video and invite your manager based on the instructions
          in the "Add Member" window.
        </p>
        <p>
          If you do not receive feedback from your manager within one to two weeks of
          posting your video, it is your responsibility to contact your manager via
          regular IBM channels (email, Slack, direct messaging, etc.) to ask them to post
          their feedback in your private channel. You should direct your manager to this link:
          <a target="_blank" href="https://ibmsales.nomadic.fm/community">https://ibmsales.nomadic.fm/community</a>
        </p>
        <p>
          <em
            >Only people you add to this channel will see your video and posts. You can
            delete your posts within channels you've created. Posts published within the
            public Stand & Deliver space or private channels created by other users cannot
            be deleted.</em
          >
        </p>
      </div>
    </div>
  </div>
  <div class="accordion">
    <input type="checkbox" name="s-d-instructions" id="s-d-receive">
    <div>
      <label for="s-d-receive">
        How do I complete the Tech Foundation for Sellers path? (ONLY RELEVANT FOR SELLERS ON THE TECH
        FOUNDATION FOR SELLERS PATH)
      </label>
      <div>
        <p>
            You're encouraged to practice here. But completion requires that you complete a 30-minute
            Stand & Deliver session (either live or over Webex) with your manager or a sales manager
            delegate.
        </p>
      </div>
    </div>
  </div>

  <div class="accordion">
  <input type="checkbox" name="s-d-instructions" id="s-d-deliver">
    <div>
      <label for="s-d-deliver">
        How do I use this channel to deliver feedback?
      </label>
      <div>
        <p>
          Post comments or general notes for improvement by replying to the seller's
          Stand & Deliver video. To submit feedback, click on a seller's post in
          this channel and compose your reply. The seller will receive a
          notification to review your feedback.
        </p>
        <p>
          If appropriate, use the downloadable interactive PDF rubric to deliver structured
          feedback on videos.
        </p>
      </div>
    </div>
  </div>

  <div class="accordion">
    <input type="checkbox" name="s-d-instructions" id="s-d-goal">
    <div>
      <label for="s-d-goal">
        What's my goal?
      </label>
      <div>
        <p>
          Over the year, you may be asked to complete a series of Stand & Deliver
          Challenges. You may choose to use this channel on-demand, to help prepare
          for your own client conversations.
        </p>
        <p>
          No two Stand & Deliver Challenges will be the same. But every successful
          Challenge response - and any pitches or conversations you practice
          independently in your Stand & Deliver Channel - should connect the dots
          between the following 5 criteria:
        </p>
        <ul>
          <li>
            Demonstrates an understanding of client's current state, business
            need/challenge, and the client's case for change (The Client's "Why")
          </li>
          <li>
            Presents a clear view of IBM's solution and benefits to address the
            client business need/challenge (IBM's "What")
          </li>
          <li>
            Demonstrates the appropriate level of technical aptitude (IBM's "How")
          </li>
          <li>
            Effectively articulates what differentiates IBM (Client's "Why IBM")
          </li>
          <li>
            Creates enthusiasm inspiring trust and an urgency for the client to act
          </li>
        </ul>
        <p>Guidelines to 'set the scene' for every Stand & Deliver in the first 30-60 seconds:</p>
        <ul>
            <li>
                Who are you talking to - the client person and his/her role?
            </li>
            <li>
                What is your relationship with this client person - e.g. strong (good trust) or
                new (building trust) or other?
            </li>
            <li>
                Which client conversation use case will you address?
            </li>
            <li>
                What's your objective for the Stand & Deliver 'conversation'?
            </li>
        </ul>
      </div>
      <p>
        Here are links to individual Stand & Deliver Challenge Resources (complete with detailed
        instructions and guidance on content and feedback):
      </p>
      <p>
        Key Cloud Conversations Guides to help you prepare and practice:
      </p>
      <ul>
        <li>
            <a target="_blank" href="/resource-library/client-conversation-app-modernization-migration">
                Modernize Applications</a>
        </li>
        <li>
            <a target="_blank" href="/resource-library/client-conversation-cloud-native">
                Build Cloud Native</a>
        </li>
        <li>
            <a target="_blank" href="/resource-library/technical-challenge-multicloud-management">
                Manage (Multicloud) IT</a>
        </li>
        <li>
            <a target="_blank" href="/resource-library/technical-challenge-infrastructure-optimization">
                Optimize IT Infrastructure</a>
        </li>
        <li>
          <a target="_blank" href="https://media-live.nomadic.fm/misc/Journey_to_Cloud_Stand_and_Deliver_Technical_Supplement.pdf">
                Quick Reference Guide to the Technical Foundations for Sellers Supplements</a>
        </li>
      </ul>
    </div>
  </div>`;

export default {
  getters: {
    standAndDeliver(state, getters) {
      let edition = getters.currentEdition;
      if (edition && edition.id === sdId) {
        return {
          channelDetails: sdChannelDetails,
          description: sdDescription,
          summary: sdSummary,
          title: sdTitle
        };
      }
      return null;
    }
  }
};
